export function isTruthy<T>(input: T | null | undefined | false | "" | 0): input is T {
	return Boolean(input);
}
